// src/hooks/useUserGeolocation.js
import { useEffect, useState } from "react";

export default function useUserGeolocation({ enabled = true } = {}) {
  const [state, setState] = useState({
    loading: false,
    error: "",
    coords: null, // { lat, lng }
  });

  useEffect(() => {
    if (!enabled) return;

    if (!("geolocation" in navigator)) {
      setState({ loading: false, error: "Geolocation not supported.", coords: null });
      return;
    }

    let cancelled = false;
    setState({ loading: true, error: "", coords: null });

    const options = { enableHighAccuracy: true, timeout: 15000, maximumAge: 30000 };

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        if (cancelled) return;
        const lat = pos?.coords?.latitude;
        const lng = pos?.coords?.longitude;
        if (lat == null || lng == null) {
          setState({ loading: false, error: "Could not read location.", coords: null });
          return;
        }
        setState({ loading: false, error: "", coords: { lat, lng } });
      },
      (err) => {
        if (cancelled) return;

        // Better error mapping
        const msg =
          err?.code === 1
            ? "Location permission denied."
            : err?.code === 2
              ? "Location unavailable (Wi-Fi/IP cannot be resolved)."
              : err?.code === 3
                ? "Location timeout. Try again."
                : err?.message || "Failed to read location.";

        setState({ loading: false, error: msg, coords: null });
      },
      options
    );

    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return state;
}
